<!--
  Diagnostics Maintenance — workspace CE view.
  Mounted when the active screen is `workspace.diagnostics-maintanence`
  (screen_key 10791). Mirrors the legacy `diag-maint-tpl.html` structure:
  Run Diagnostics top bar, table with per-column filter dropdowns, and an
  edit modal that swaps Legal Entities between enabled / disabled lists.
  Workspace filter bar (tax year / scenario / ME) lives in the outer
  `gtw-data-filters` host; this template never duplicates it.
-->
@if (isDiagMaintWorkspaceMode) {

  <div class="diag-maint-host">
    @if (loadingList) {
<div class="diag-loader-overlay">
      <i class="fa fa-spinner fa-spin"></i>
      <span class="loader-text">Fetching data...</span>
    </div>
}

    @if (!loadingList && diagList.length === 0) {
<div class="diag-empty-placeholder">
      <i class="fa fa-filter"></i>
      <p>Select your filters above and click <strong>Filter</strong> to load diagnostics.</p>
    </div>
}

    @if (!loadingList && diagList.length > 0 && diagListCopy.length === 0) {
<div
      class="diag-empty-placeholder no-match"
     >
      <i class="fa fa-search"></i>
      <p>No diagnostics match the current search or filters.</p>
    </div>
}

    <!--
      Run Diagnostics is only meaningful once the grid has fetched data —
      hide the action bar until `diagList` has at least one row (which is
      also when the column-filter dropdowns become populated). This avoids
      a lone button rendering over the empty-state placeholder.
    -->
    @if (diagList.length > 0) {
<div class="diag-top-bar">
      <button
        type="button"
        class="save-button"
        [disabled]="runningDiagnostics"
        (click)="runDiagnostics()">
        @if (runningDiagnostics) {
<i class="fa fa-spinner fa-pulse"></i>
}
        Run Diagnostics
      </button>
      <div class="diag-search-wrap">
        <i class="fa fa-search diag-search-icon"></i>
        <input
          type="text"
          class="diag-search-input"
          placeholder="Search diagnostics..."
          [ngModel]="diagSearchTerm"
          (ngModelChange)="onDiagSearchChange($event)" />
        @if (diagSearchTerm) {
<i
          class="fa fa-times-circle diag-search-clear"
         
          (click)="clearDiagSearch()"
          title="Clear search"></i>
}
      </div>
    </div>
}

    @if (!loadingList && diagListCopy.length > 0) {
<div class="diag-maint-body-container">
      <table class="diag-maint-datatable">
        <thead>
          <tr class="datatable-th">
            <th class="sortable-col" (click)="sortDiagBy('DIAG_KEY')">
              <span class="header-label">Diagnostics Key</span>
              <i class="fa sort-caret"
                 [class.fa-sort]="diagSortIndicator('DIAG_KEY') === ''"
                 [class.fa-sort-asc]="diagSortIndicator('DIAG_KEY') === 'asc'"
                 [class.fa-sort-desc]="diagSortIndicator('DIAG_KEY') === 'desc'"></i>
            </th>
            <th class="sortable-col" (click)="sortDiagBy('DIAG_DESC')">
              <span class="header-label">Diagnostics</span>
              <i class="fa sort-caret"
                 [class.fa-sort]="diagSortIndicator('DIAG_DESC') === ''"
                 [class.fa-sort-asc]="diagSortIndicator('DIAG_DESC') === 'asc'"
                 [class.fa-sort-desc]="diagSortIndicator('DIAG_DESC') === 'desc'"></i>
            </th>
            <th class="column-with-filter sortable-col" (click)="sortDiagBy('CATEGORY_DESC')">
              <span class="header-label">Category</span>
              <i class="fa sort-caret"
                 [class.fa-sort]="diagSortIndicator('CATEGORY_DESC') === ''"
                 [class.fa-sort-asc]="diagSortIndicator('CATEGORY_DESC') === 'asc'"
                 [class.fa-sort-desc]="diagSortIndicator('CATEGORY_DESC') === 'desc'"></i>
              <i
                class="fa fa-filter filter-icon"
                [class.filter-on]="isFilterApplied('category-filter-menu')"
                (click)="openFilter('category-filter-menu', $event)"></i>
              @if (openFilterId === 'category-filter-menu') {
<div
                class="diag-maint-filter"
               
                (click)="$event.stopPropagation()">
                <div class="filter-search-container">
                  <input
                    class="filter-search"
                    type="text"
                    placeholder="Search category..."
                    [(ngModel)]="filterSearchTerm" />
                </div>
                <div class="filter-selection-container">
                  <label>
                    <input
                      type="checkbox"
                      [checked]="categorySelectAll"
                      (change)="onFilterSelectAllChange('category-filter-menu', $any($event.target).checked)" />
                    Select All
                  </label>
                  @for (key of filterKeys('category-filter-menu'); track $index) {

                    @if (isFilterKeyVisible(key)) {
<label>
                      <input
                        type="checkbox"
                        [checked]="key.selected"
                        (change)="onFilterKeySelectionChange('category-filter-menu', key, $any($event.target).checked)" />
                      {{ key.label }}
                    </label>
}
                  
}
                </div>
                <div class="filter-footer">
                  <button type="button" class="cancel-button filter-btn" (click)="closeFilters()">Cancel</button>
                  <button type="button" class="save-button filter-btn" (click)="applyDiagFilters('category-filter-menu')">OK</button>
                </div>
              </div>
}
            </th>
            <th class="column-with-filter sortable-col" (click)="sortDiagBy('SUBCATEGORY_DESC')">
              <span class="header-label">Subcategory</span>
              <i class="fa sort-caret"
                 [class.fa-sort]="diagSortIndicator('SUBCATEGORY_DESC') === ''"
                 [class.fa-sort-asc]="diagSortIndicator('SUBCATEGORY_DESC') === 'asc'"
                 [class.fa-sort-desc]="diagSortIndicator('SUBCATEGORY_DESC') === 'desc'"></i>
              <i
                class="fa fa-filter filter-icon"
                [class.filter-on]="isFilterApplied('subcat-filter-menu')"
                (click)="openFilter('subcat-filter-menu', $event)"></i>
              @if (openFilterId === 'subcat-filter-menu') {
<div
                class="diag-maint-filter"
               
                (click)="$event.stopPropagation()">
                <div class="filter-search-container">
                  <input
                    class="filter-search"
                    type="text"
                    placeholder="Search subcategory..."
                    [(ngModel)]="filterSearchTerm" />
                </div>
                <div class="filter-selection-container">
                  <label>
                    <input
                      type="checkbox"
                      [checked]="subcatSelectAll"
                      (change)="onFilterSelectAllChange('subcat-filter-menu', $any($event.target).checked)" />
                    Select All
                  </label>
                  @for (key of filterKeys('subcat-filter-menu'); track $index) {

                    @if (isFilterKeyVisible(key)) {
<label>
                      <input
                        type="checkbox"
                        [checked]="key.selected"
                        (change)="onFilterKeySelectionChange('subcat-filter-menu', key, $any($event.target).checked)" />
                      {{ key.label }}
                    </label>
}
                  
}
                </div>
                <div class="filter-footer">
                  <button type="button" class="cancel-button filter-btn" (click)="closeFilters()">Cancel</button>
                  <button type="button" class="save-button filter-btn" (click)="applyDiagFilters('subcat-filter-menu')">OK</button>
                </div>
              </div>
}
            </th>
            <th class="column-with-filter sortable-col" (click)="sortDiagBy('DIAG_MSG')">
              <span class="header-label">Message</span>
              <i class="fa sort-caret"
                 [class.fa-sort]="diagSortIndicator('DIAG_MSG') === ''"
                 [class.fa-sort-asc]="diagSortIndicator('DIAG_MSG') === 'asc'"
                 [class.fa-sort-desc]="diagSortIndicator('DIAG_MSG') === 'desc'"></i>
              <i
                class="fa fa-filter filter-icon"
                [class.filter-on]="isFilterApplied('msg-filter-menu')"
                (click)="openFilter('msg-filter-menu', $event)"></i>
              @if (openFilterId === 'msg-filter-menu') {
<div
                class="diag-maint-filter"
               
                (click)="$event.stopPropagation()">
                <div class="filter-search-container">
                  <input
                    class="filter-search"
                    type="text"
                    placeholder="Search message..."
                    [(ngModel)]="filterSearchTerm" />
                </div>
                <div class="filter-selection-container">
                  <label>
                    <input
                      type="checkbox"
                      [checked]="msgSelectAll"
                      (change)="onFilterSelectAllChange('msg-filter-menu', $any($event.target).checked)" />
                    Select All
                  </label>
                  @for (key of filterKeys('msg-filter-menu'); track $index) {

                    @if (isFilterKeyVisible(key)) {
<label>
                      <input
                        type="checkbox"
                        [checked]="key.selected"
                        (change)="onFilterKeySelectionChange('msg-filter-menu', key, $any($event.target).checked)" />
                      {{ key.label }}
                    </label>
}
                  
}
                </div>
                <div class="filter-footer">
                  <button type="button" class="cancel-button filter-btn" (click)="closeFilters()">Cancel</button>
                  <button type="button" class="save-button filter-btn" (click)="applyDiagFilters('msg-filter-menu')">OK</button>
                </div>
              </div>
}
            </th>
            <th class="text-center action-col">Action</th>
          </tr>
        </thead>
        <tbody>
          @for (row of diagListCopy; track trackByDiagKey($index, row)) {
<tr
           
            class="datatable-td"
            [class.disabled-row]="!row.DIAG_SWITCH">
            <td>{{ row.DIAG_KEY }}</td>
            <td>
              <a (click)="openEditDiag(row)">{{ row.DIAG_DESC }}</a>
            </td>
            <td>{{ row.CATEGORY_DESC }}</td>
            <td>{{ row.SUBCATEGORY_DESC }}</td>
            <td>{{ row.DIAG_MSG }}</td>
            <td>
              <span class="actions">
                <span class="btn-group">
                  <button
                    type="button"
                    class="btn btn-enable"
                    [class.btn-success]="row.DIAG_SWITCH"
                    [disabled]="togglingDiagKey === row.DIAG_KEY"
                    (click)="onToggleDiag(row, 1)">
                    Enable
                  </button>
                  <button
                    type="button"
                    class="btn"
                    [class.btn-warning]="!row.DIAG_SWITCH"
                    [disabled]="togglingDiagKey === row.DIAG_KEY"
                    (click)="onToggleDiag(row, 0)">
                    Disable
                  </button>
                </span>
                <button
                  type="button"
                  class="btn btn-edit"
                  [disabled]="!row.DIAG_SWITCH"
                  (click)="openEditDiag(row)">
                  Edit
                </button>
              </span>
            </td>
          </tr>
}
        </tbody>
      </table>
    </div>
}
  </div>

  <!--
    Edit Diagnostic modal — inline overlay (mirrors legacy edit-diag-modal.html).
    The workspace CE is mounted inside the workspace shell, so a MatDialog
    isn't needed; a fixed-position overlay keeps the implementation simple
    and avoids cross-module DOM teardown timing issues.
  -->
  @if (editModalOpen) {
<div class="diag-edit-modal-backdrop" (click)="cancelEditDiag()"></div>
}
  @if (editModalOpen) {
<div class="diag-edit-modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3 class="modal-title">
        Edit {{ selectedDiag?.DIAG_KEY }} - {{ selectedDiag?.DIAG_DESC }}
      </h3>
      <div class="header-actions">
        <i class="fa fa-times" style="cursor: pointer;" (click)="cancelEditDiag()"></i>
      </div>
    </div>
    <div class="modal-body">
      <div class="edit-row">
        <div class="edit-col">
          <label>Category:</label>
          <select class="form-control" [(ngModel)]="editSelectedCat">
            <option [ngValue]="null" disabled>Select Category</option>
            @for (cat of categories; track $index) {
<option [ngValue]="cat">{{ cat.CATEGORY_DESC }}</option>
}
          </select>
          <label>Subcategory:</label>
          <select class="form-control" [(ngModel)]="editSelectedSubcat">
            <option [ngValue]="null" disabled>Select Subcategory</option>
            @for (sub of subcategories; track $index) {
<option [ngValue]="sub">{{ sub.SUBCATEGORY_DESC }}</option>
}
          </select>
          <label>Message:</label>
          <select class="form-control" [(ngModel)]="editSelectedMsg">
            <option [ngValue]="null" disabled>Select Message</option>
            @for (msg of messages; track $index) {
<option [ngValue]="msg">{{ msg.DIAG_MSG }}</option>
}
          </select>

          @if (editLoadingLEs) {
<div class="list-loader">
            <i class="fa fa-spinner fa-spin"></i> Loading disabled entities...
          </div>
}
          @if (!editLoadingLEs) {
<div class="disabled-le-list-container">
            <label class="list-header">Disabled Legal Entities</label>
            @if (editDisabledLEs.length === 0) {
<p class="no-data-msg">No Disabled Entities...</p>
}
            @if (editDisabledLEs.length > 0) {

              <input
                class="form-control"
                type="text"
                placeholder="Search Disabled Entity..."
                [(ngModel)]="editDisabledSearchTerm" />
              <label class="select-all-row">
                <input
                  type="checkbox"
                  (change)="selectAllDisabledInEdit($any($event.target).checked)" />
                Select All
              </label>
              <div class="disabled-entities">
                @for (dis of editDisabledLEs; track trackByLeId($index, dis)) {

                  @if (isEntityVisible(dis, editDisabledSearchTerm)) {
<label class="vs-item">
                    <input type="checkbox" [(ngModel)]="dis.selected" />
                    {{ dis.TAX_PAYER }}
                  </label>
}
                
}
              </div>
            
}
            <button type="button" class="reset-button list-btn" (click)="removeEntitiesFromDisabled()">
              Remove Selected Entities
            </button>
          </div>
}
        </div>

        <div class="edit-col">
          @if (editLoadingEntities) {
<div class="list-loader">
            <i class="fa fa-spinner fa-spin"></i> Loading all entities...
          </div>
}
          @if (!editLoadingEntities && editAllEntities.length === 0) {
<p class="no-data-msg">
            No Entities available...
          </p>
}
          @if (editAllEntities.length > 0) {

            <input
              class="form-control"
              type="text"
              placeholder="Search Entity..."
              [(ngModel)]="editEntitySearchTerm" />
            <label class="select-all-row">
              <input
                type="checkbox"
                (change)="selectAllEntitiesInEdit($any($event.target).checked)" />
              Select All
            </label>
            <div class="entities">
              @for (entity of editAllEntities; track trackByLeId($index, entity)) {

                @if (isEntityVisible(entity, editEntitySearchTerm)) {
<label class="vs-item">
                  <input type="checkbox" [(ngModel)]="entity.selected" />
                  {{ entity.TAX_PAYER }}
                </label>
}
              
}
            </div>
          
}
          <button type="button" class="save-button list-btn" (click)="addEntitiesToDisabled()">
            Add Selected Entities
          </button>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="save-button" [disabled]="editSaving" (click)="saveEditDiag()">
        @if (editSaving) {
<i class="fa fa-spinner fa-pulse"></i>
}
        Save
      </button>
      <button type="button" class="cancel-button" [disabled]="editSaving" (click)="cancelEditDiag()">
        Cancel
      </button>
    </div>
  </div>
}

} @else {

  <div class="entity-mgmt-app-shell">
    <div class="app-nav index-sticky-header">
      <ul>
        <li><a [class.active]="activeTab === 'list'" (click)="setTab('list')">Entity List</a></li>
        <li><a [class.active]="activeTab === 'details'" (click)="setTab('details')">Entity Details</a></li>
        <li><a [class.active]="activeTab === 'diagSummary'" (click)="setTab('diagSummary')">Diagnostic Summary</a></li>
        <li><a [class.active]="activeTab === 'diagMaint'" (click)="setTab('diagMaint')">Diagnostic Maintenance</a></li>
        <li class="separator"><i class="fa fa-ellipsis-v"></i></li>
      </ul>
    </div>

    <div class="app-body">
      <div class="actions">
        <button type="button" class="save-button" (click)="onRefresh()">Refresh</button>
        <button type="button" class="cancel-button" (click)="onCancel()">Cancel</button>
      </div>

      @if (loadingList) {
<div class="formLoader">
        <i class="fa fa-spinner fa-spin gt-refresh"></i>
      </div>
}

      @if (!loadingList && errorMessage) {
<div class="error">{{ errorMessage }}</div>
}

      @if (!loadingList && !errorMessage && (activeTab === 'list' || activeTab === 'details')) {
<div class="content">
        <div class="list-pane">
          @if (entities.length > 0) {
<table class="table table-bordered form-inline custom-table">
            <thead>
              <tr>
                @for (col of entities[0] | keyvalue; track col.key) {
<th>{{ col.key }}</th>
}
              </tr>
            </thead>
            <tbody>
              @for (row of entities; track $index) {
<tr (click)="selectEntity(row)" [class.active-row]="row === selectedEntity">
                @for (col of row | keyvalue; track col.key) {
<td>{{ col.value }}</td>
}
              </tr>
}
            </tbody>
          </table>
}
          @if (entities.length === 0) {
<div class="no-data">No entities returned for the current filters.</div>
}
        </div>

        @if (activeTab === 'details') {
<div class="details-pane">
          <h4>
            Entity Details
            @if (detailRows.length > 0) {
<span class="table-edit-save">
              @if (!enableEdit) {
<i class="fa fa-pencil pull-right" (click)="toggleEdit()"></i>
}
              @if (enableEdit) {
<i class="fa fa-times pull-right" (click)="toggleEdit()"></i>
}
              @if (enableEdit && !savingDetails) {
<i class="fa fa-save pull-right" (click)="saveDetails()"></i>
}
              @if (enableEdit && savingDetails) {
<i class="fa fa-spinner fa-spin pull-right"></i>
}
            </span>
}
          </h4>
          @if (loadingDetails) {
<div class="formLoader">
            <i class="fa fa-spinner fa-spin gt-refresh"></i>
          </div>
}
          @if (!loadingDetails && detailRows.length > 0 && !enableEdit) {
<table class="table table-bordered form-inline custom-table">
            <tbody>
              @for (item of detailRows; track $index) {
<tr>
                <td class="detail-key"><strong>{{ item.key }}</strong></td>
                <td>{{ item.value }}</td>
              </tr>
}
            </tbody>
          </table>
}
          @if (!loadingDetails && detailRows.length > 0 && enableEdit) {
<table class="table table-bordered form-inline custom-table">
            <tbody>
              @for (item of detailRows; track $index) {
<tr>
                <td class="detail-key"><strong>{{ item.key }}</strong></td>
                <td>
                  <input
                    class="form-control"
                    [ngModel]="entityDetailsEdit ? entityDetailsEdit[item.key] : ''"
                    (ngModelChange)="entityDetailsEdit[item.key] = $event"
                  />
                </td>
              </tr>
}
            </tbody>
          </table>
}
          @if (!loadingDetails && (addressList.length > 0 || enableEdit)) {
<div class="section-card">
            <h5>
              Address Details
              @if (enableEdit) {
<span class="table-edit-save">
                <i class="fa fa-plus-square-o pull-right" (click)="addAddressRow()"></i>
                @if (!addressSaving) {
<i class="fa fa-save pull-right" (click)="saveAddressDetails()"></i>
}
                @if (addressSaving) {
<i class="fa fa-spinner fa-spin pull-right"></i>
}
              </span>
}
            </h5>
            <table class="table table-bordered form-inline custom-table">
              <thead>
                <tr>
                  <th>Address 1</th>
                  <th>Address 2</th>
                  <th>City</th>
                  <th>County</th>
                  <th>State</th>
                  <th>Country</th>
                  <th>Zip</th>
                  @if (enableEdit) {
<th>Action</th>
}
                </tr>
              </thead>
              @if (!enableEdit) {
<tbody>
                @for (row of addressList; track $index) {
<tr>
                  <td>{{ row.reg_address_line1 }}</td>
                  <td>{{ row.reg_address_line2 }}</td>
                  <td>{{ row.reg_address_city }}</td>
                  <td>{{ row.reg_address_county }}</td>
                  <td>{{ row.reg_address_state }}</td>
                  <td>{{ row.reg_address_country }}</td>
                  <td>{{ row.reg_address_zip }}</td>
                </tr>
}
              </tbody>
}
              @if (enableEdit) {
<tbody>
                @for (row of addressListEdit; track $index; let i = $index) {
<tr>
                  <td><input class="form-control" [ngModel]="row.reg_address_line1 || ''" (ngModelChange)="row.reg_address_line1 = $event" /></td>
                  <td><input class="form-control" [ngModel]="row.reg_address_line2 || ''" (ngModelChange)="row.reg_address_line2 = $event" /></td>
                  <td><input class="form-control" [ngModel]="row.reg_address_city || ''" (ngModelChange)="row.reg_address_city = $event" /></td>
                  <td><input class="form-control" [ngModel]="row.reg_address_county || ''" (ngModelChange)="row.reg_address_county = $event" /></td>
                  <td><input class="form-control" [ngModel]="row.reg_address_state || ''" (ngModelChange)="row.reg_address_state = $event" /></td>
                  <td><input class="form-control" [ngModel]="row.reg_address_country || ''" (ngModelChange)="row.reg_address_country = $event" /></td>
                  <td><input class="form-control" [ngModel]="row.reg_address_zip || ''" (ngModelChange)="row.reg_address_zip = $event" /></td>
                  <td><i class="fa fa-trash" (click)="removeAddressRow(i)"></i></td>
                </tr>
}
              </tbody>
}
            </table>
          </div>
}
          @if (!loadingDetails && (ownershipList.length > 0 || enableEdit)) {
<div class="section-card">
            <h5>
              Ownership Details
              @if (enableEdit) {
<span class="table-edit-save">
                <i class="fa fa-plus-square-o pull-right" (click)="addOwnershipRow()"></i>
                @if (!ownershipSaving) {
<i class="fa fa-save pull-right" (click)="saveOwnershipDetails()"></i>
}
                @if (ownershipSaving) {
<i class="fa fa-spinner fa-spin pull-right"></i>
}
              </span>
}
            </h5>
            <table class="table table-bordered form-inline custom-table">
              <thead>
                <tr>
                  <th>Parent LE</th>
                  <th>Ownership Type</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Ownership %</th>
                  @if (enableEdit) {
<th>Action</th>
}
                </tr>
              </thead>
              @if (!enableEdit) {
<tbody>
                @for (row of ownershipList; track $index) {
<tr>
                  <td>{{ row.parent_legal_entity_name }}</td>
                  <td>{{ row.ownership_type_desc }}</td>
                  <td>{{ row.start_date }}</td>
                  <td>{{ row.end_date }}</td>
                  <td>{{ row.ownership_perc }}</td>
                </tr>
}
              </tbody>
}
              @if (enableEdit) {
<tbody>
                @for (row of ownershipListEdit; track $index; let i = $index) {
<tr>
                  <td><input class="form-control" [ngModel]="row.parent_legal_entity_name || ''" (ngModelChange)="row.parent_legal_entity_name = $event" /></td>
                  <td><input class="form-control" [ngModel]="row.ownership_type_desc || ''" (ngModelChange)="row.ownership_type_desc = $event" /></td>
                  <td><input class="form-control" [ngModel]="row.start_date || ''" (ngModelChange)="row.start_date = $event" /></td>
                  <td><input class="form-control" [ngModel]="row.end_date || ''" (ngModelChange)="row.end_date = $event" /></td>
                  <td><input class="form-control" [ngModel]="row.ownership_perc || ''" (ngModelChange)="row.ownership_perc = $event" /></td>
                  <td><i class="fa fa-trash" (click)="removeOwnershipRow(i)"></i></td>
                </tr>
}
              </tbody>
}
            </table>
          </div>
}
          @if (!loadingDetails && detailRows.length === 0) {
<div class="no-data">Select an entity to view details.</div>
}
        </div>
}
      </div>
}

      @if (activeTab === 'diagSummary') {
<div class="content diag-pane">
        <div class="actions">
          <button type="button" class="save-button" (click)="runDiagnostics()">Run Diagnostics</button>
        </div>
        @if (loadingDiag) {
<div class="formLoader">
          <i class="fa fa-spinner fa-spin gt-refresh"></i>
        </div>
}
        @if (!loadingDiag && diagList.length > 0) {
<table class="table table-bordered form-inline custom-table">
          <thead>
            <tr>
              @for (col of diagList[0] | keyvalue; track col.key) {
<th>{{ col.key }}</th>
}
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            @for (row of diagList; track $index) {
<tr>
              @for (col of row | keyvalue; track col.key) {
<td>{{ col.value }}</td>
}
              <td>
                <button type="button" class="reset-button" (click)="onToggleDiag(row, row.DIAG_SWITCH ? 0 : 1)">
                  {{ row.DIAG_SWITCH ? 'Disable' : 'Enable' }}
                </button>
                <button type="button" class="save-button" (click)="openEditDiag(row)">Edit</button>
              </td>
            </tr>
}
          </tbody>
        </table>
}
        @if (!loadingDiag && diagList.length === 0) {
<div class="no-data">No diagnostics available.</div>
}
      </div>
}

      @if (activeTab === 'diagMaint') {
<div class="content diag-pane">
        @if (loadingDiag) {
<div class="formLoader">
          <i class="fa fa-spinner fa-spin gt-refresh"></i>
        </div>
}
        @if (!loadingDiag) {
<div class="diag-maint-wrap">
          <div class="diag-card">
            <h4>Category</h4>
            <select class="form-control" [(ngModel)]="editDiagPayload.cat_key">
              <option value="">Select</option>
              @for (item of categories; track $index) {
<option [value]="item.CAT_KEY">{{ item.CATEGORY_DESC || item.CAT_NAME || item.LABEL }}</option>
}
            </select>
          </div>
          <div class="diag-card">
            <h4>Subcategory</h4>
            <select class="form-control" [(ngModel)]="editDiagPayload.subcat_key">
              <option value="">Select</option>
              @for (item of subcategories; track $index) {
<option [value]="item.SUBCAT_KEY">{{ item.SUBCATEGORY_DESC || item.SUBCAT_NAME || item.LABEL }}</option>
}
            </select>
          </div>
          <div class="diag-card">
            <h4>Message</h4>
            <select class="form-control" [(ngModel)]="editDiagPayload.diag_msg">
              <option value="">Select</option>
              @for (item of messages; track $index) {
<option [value]="item.DIAG_MSG || item.LABEL">{{ item.DIAG_MSG || item.LABEL }}</option>
}
            </select>
          </div>
          <div class="diag-card entity-select-card">
            <h4>Disabled Legal Entities</h4>
            <div class="entity-actions-bar">
              <label><input type="checkbox" (change)="selectAllDisabledPanel($any($event.target).checked)" /> Select All</label>
              <button type="button" class="reset-button" (click)="removeEntitiesPanel()">Remove Selected</button>
            </div>
            <div class="entity-list">
              @for (item of disabledEntities; track $index) {
<label>
                <input type="checkbox" [checked]="item.selected" (change)="item.selected = $any($event.target).checked" />
                {{ item.LEID }} - {{ item.TAX_PAYER }}
              </label>
}
            </div>
          </div>
          <div class="diag-card entity-select-card">
            <h4>All Legal Entities</h4>
            <div class="entity-actions-bar">
              <label><input type="checkbox" (change)="selectAllEntitiesPanel($any($event.target).checked)" /> Select All</label>
              <button type="button" class="save-button" (click)="addEntitiesPanel()">Add Selected</button>
            </div>
            <div class="entity-list">
              @for (item of allEntities; track $index) {
<label>
                <input type="checkbox" [checked]="item.selected" (change)="item.selected = $any($event.target).checked" />
                {{ item.LEID }} - {{ item.TAX_PAYER }}
              </label>
}
            </div>
          </div>
          <div class="diag-actions">
            <button type="button" class="save-button" [disabled]="!selectedDiag" (click)="saveEditedDiag()">Save Diagnostic</button>
          </div>
        </div>
}
      </div>
}
    </div>
  </div>

}

<!--
  Standalone shell — kept for the legacy `/entity-mgmt` route which renders
  the multi-tab Entity Management UI directly (not via the workspace).
-->

